import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { AnimationExportFormat } from "./index";

interface ExportAnimationProgressDialogProps {
  open: boolean;
  format: AnimationExportFormat;
  progress: number;
  /** 不传则默认「正在导出 {format} 动图」 */
  title?: string;
}

export function ExportAnimationProgressDialog({
  open,
  format,
  progress,
  title,
}: ExportAnimationProgressDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        className="max-w-sm"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>
            {title ?? `正在导出 ${format.toUpperCase()} 动图`}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="h-2.5 w-full rounded-full bg-muted overflow-hidden">
            <div
              className="h-full rounded-full bg-primary transition-all duration-200"
              style={{ width: `${Math.round(progress * 100)}%` }}
            />
          </div>
          <p className="text-sm text-muted-foreground text-center">
            {format === "gif" ? (
              progress < 0.5
                ? `录制帧画面 ${Math.round(progress * 200)}%`
                : `编码 GIF ${Math.round((progress - 0.5) * 200)}%`
            ) : progress < 0.4 ? (
              `录制帧画面 ${Math.round((progress / 0.4) * 100)}%`
            ) : progress < 0.8 ? (
              `编码 WebP 帧 ${Math.round(((progress - 0.4) / 0.4) * 100)}%`
            ) : (
              `组装文件 ${Math.round(((progress - 0.8) / 0.2) * 100)}%`
            )}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
